import { formatDate } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { parseAsync } from 'json2csv';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ApBaseComponent } from 'webcommon/core-ui';
import { BrowserService } from 'webcommon/legacy-common';
import { FPAppointmentsSearchResultDto, FPDocumentPrintingEventArgs } from 'webcommon/shared';
import { FPDocumentPrintingService } from '../fp-document-printing/index';
import { FPAppointmentPrintContentComponent } from './fp-appointment-print-content';

@Component({
  selector: 'fp-appointment-results',
  styleUrls: ['./fp-appointment-results.component.less'],
  templateUrl: './fp-appointment-results.component.html',
})
export class FPAppointmentResultsComponent extends ApBaseComponent implements OnInit, OnChanges {
  @Input() baseId?: string;
  @Input() searchResult?: FPAppointmentsSearchResultDto[];

  Id: string;
  currentPage = 1;
  disablePrint = true;
  resultView: FPAppointmentsSearchResultDto[] = [];
  numberOfResults = '0';
  totalItems = 0;

  opts = {
    fields: [
      'AppointmentType',
      {
        label: 'Date',
        value: (row: FPAppointmentsSearchResultDto) => formatDate(row.Date, 'MM/dd/yyyy', 'en-us'),
      },
      {
        label: 'Time',
        value: (row: FPAppointmentsSearchResultDto) => formatDate(row.Date, 'shortTime', 'en-us'),
      },
      'PatientName',
      'RenderingProvider',
      'ServiceSite',
    ],
  };

  constructor(
    private browserService: BrowserService,
    private documentPrintingService: FPDocumentPrintingService,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.searchResult) {
        this.updateSearchResults();
      }
    }
  }

  ngOnInit() {
    this.setId();
    this.load();
  }

  pageChanged(pageChangedEvent: PageChangedEvent) {
    this.setPage(pageChangedEvent.page);
  }

  saveAsCsv() {
    if (this.searchResult) {
      parseAsync(this.searchResult, this.opts)
        .then((csv) => {
          const dataUri = 'data:text/csv;charset-utf-8,' + encodeURI(csv);
          const filename = 'appointments.csv';
          this.browserService.saveDataUri(
            this.browserService.getDocument(),
            dataUri,
            filename,
          );
        })
        .catch((err) => console.log(err));
    }
  }

  setPage(pageNumber: number): void {
    this.currentPage = pageNumber;
    if (this.searchResult) {
       this.resultView = this.searchResult.slice(10 * (pageNumber - 1), (10 * (pageNumber)));
    }
  }

  private load() {
    this.loading = false;
    this.updateSearchResults();
  }

  private setId() {
    this.Id = this.baseId + '-appointment-results';
  }

  private updateSearchResults() {
    this.disablePrint = true;
    if (this.searchResult) {
      this.totalItems = this.searchResult.length;

      if (this.totalItems >= 100) {
        this.numberOfResults = '100+';
      } else {
        this.numberOfResults = this.totalItems.toString();
      }

      const eventArgs: FPDocumentPrintingEventArgs = {
        Component: FPAppointmentPrintContentComponent,
        Data: this.searchResult,
      };

      this.documentPrintingService.notifyDocumentChanged(eventArgs);
      if (this.searchResult.length > 0) {
        setTimeout(() => {
          this.disablePrint = false;
        }, 250);
      }
    } else {
      this.totalItems = 0;
    }

    setTimeout(() => {
      this.setPage(1);
    }, 250);
  }
}
